import React, { useEffect, useState } from "react";
import { SlidePages } from "../../components/slidePages";
import { ITE } from "../../components/detailsBlog/ITE";
import { AvantagesSection } from "../../components/detailsBlog/avantages";
import { Inconvenients } from "../../components/detailsBlog/Inconvenients";
import { ITI } from "../../components/detailsBlog/ITI";
import { ThermiquesIcon } from "../../assets/icons/ThermiquesIcon";
import { HabitIcon } from "../../assets/icons/HabitIcon";
import { EsthetiqueIcon } from "../../assets/icons/EsthetiqueIcon";
import { ImmobiliereIcon } from "../../assets/icons/ImmobiliereIcon";
import { CoûtIcon } from "../../assets/icons/CoûtIcon";
import { OuvreIcon } from "../../assets/icons/OuvreIcon";
import { LogementIcon } from "../../assets/icons/LogementIcon";

import { DeclarationIcon } from "../../assets/icons/DeclarationIcon";
import { TravauxIcon } from "../../assets/icons/TravauxIcon";
import { HabitableIcon } from "../../assets/icons/HabitableIcon";
import { Thermiques } from "../../assets/icons/Thermiques";
import { PeintureIcon } from "../../assets/icons/PeintureIcon";
import { AutreBlog } from "../../components/detailsBlog/autreBlog";
import { useParams } from "react-router-dom";
import BlogService from "../../services/blog/blog.service";
import { showErrorToaster } from "../../components/toaster/error";
const blogService = new BlogService();
export const DetailsBlog = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState();
  useEffect(() => {
    if (id) {
      // Si un ID est présent, on charge les données existantes pour l'édition
      const fetchBlog = async () => {
        try {
          const response = await blogService.getBlogById(id);
          setFormData(response.data);
        } catch (error) {
          showErrorToaster("Erreur lors du chargement des données.");
        }
      };
      fetchBlog();
    }
  }, [id]);
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(id) {
    return `${apiUrl}/blogs/${id}/image`;
  }

  const avantages = [
    {
      icon: <ThermiquesIcon />,
      text: "Réduction optimale des ponts thermiques",
    },
    {
      icon: <HabitIcon />,
      text: "Aucun impact sur la surface habitable",
    },
    {
      icon: <EsthetiqueIcon />,
      text: "Amélioration de l’esthétique de la façade",
    },
    {
      icon: <ImmobiliereIcon />,
      text: "Forte plus-value immobilière",
    },
  ];
  const avantages1 = [
    {
      icon: <CoûtIcon />,
      text: "Moins coûteux à court terme",
    },
    {
      icon: <OuvreIcon />,
      text: "Rapide à mettre en œuvre",
    },
    {
      icon: <LogementIcon />,
      text: "Idéal en rénovation légère ou logement occupé",
    },
  ];
  const inconvenients = [
    {
      icon: <CoûtIcon />,
      text: "Coût plus élevé que l’ITI",
    },
    {
      icon: <DeclarationIcon />,
      text: "Déclaration préalable de travaux nécessaire",
    },
    {
      icon: <TravauxIcon />,
      text: "Travaux extérieurs plus visibles et longs",
    },
  ];
  const inconvenients1 = [
    {
      icon: <HabitableIcon />,
      text: "Perte de surface habitable",
    },
    {
      icon: <Thermiques />,
      text: "Ponts thermiques plus difficiles à traiter",
    },
    {
      icon: <PeintureIcon />,
      text: "Nécessite la reprise des finitions (peinture, prises, etc.)",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages title={formData?.title} description={formData?.description} />
      <ITE />
      <AvantagesSection
        avantages={avantages}
        description={
          "Un confort thermique durable et une façade entièrement rénovée."
        }
      />
      <Inconvenients
        inconvenients={inconvenients}
        description={
          "Une solution performante, mais avec quelques contraintes à anticiper."
        }
      />
      <ITI />
      <AvantagesSection
        avantages={avantages1}
        description={
          "ne solution simple, rapide et économique pour améliorer votre confort."
        }
      />
      <Inconvenients
        inconvenients={inconvenients1}
        description={
          "Une solution économique, mais avec quelques compromis à prévoir."
        }
      />
      <AutreBlog />
    </div>
  );
};
